import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSelectWrapper } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import { expiresOnOptions } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';

export interface ExpirationOptionSelectProps {
  name: string;
  id: string;
  disabled?: boolean;
}

export function ExpirationOptionSelect({
  name,
  id,
  disabled,
}: ExpirationOptionSelectProps): JSX.Element {
  const { control, errors } = useFormContext();

  return (
    <CookbookSelectWrapper
      label="Deactivate (optional)"
      name={name}
      id={id}
      disabled={disabled}
      options={expiresOnOptions}
      error={errors[name]}
      control={control}
      blockWidth
    />
  );
}
